<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
  <path fill="url(#bg_messages)" d="M40 .25C61.953.25 79.75 18.047 79.75 40S61.953 79.75 40 79.75.25 61.953.25 40 18.047.25 40 .25"/>
  <path stroke="url(#border_messages)" stroke-width=".5" d="M40 .25C61.953.25 79.75 18.047 79.75 40S61.953 79.75 40 79.75.25 61.953.25 40 18.047.25 40 .25Z"/>
  <g stroke="#FFBA42" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5">
    <path d="M47 45.5L51.5 50V35C51.5 31.686 48.814 29 45.5 29H31.5C28.186 29 25.5 31.686 25.5 35V44C25.5 47.314 28.186 50 31.5 50H42.5L47 45.5Z"/>
    <path d="M32 36H45M32 42H40"/>
  </g>
  <defs>
    <linearGradient id="bg_messages" x1="83.625" x2="21.485" y1="80.021" y2="-20.52" gradientUnits="userSpaceOnUse">
      <stop stop-color="#13142B"/>
      <stop offset="1" stop-color="#050621"/>
    </linearGradient>
    <linearGradient id="border_messages" x1="40" x2="40" y1="0" y2="80" gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFA100"/>
      <stop offset="1" stop-color="#996100" stop-opacity=".5"/>
    </linearGradient>
  </defs>
</svg>
